import { useRef, useState } from 'react';
// material
import { alpha, useTheme } from '@mui/material/styles';
import { Box, MenuItem, ListItemText, IconButton } from '@mui/material';
// components
import MenuPopover from '../../components/MenuPopover';
import { useLocalization } from '../../common/LocalizationProvider';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function LanguagePopover() {
  const { languages, language, setLanguage } = useLocalization();
  const theme = useTheme();

  const languageList = Object.entries(languages).map((values) => ({
    code: values[0],
    name: values[1].name
  }));

  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = (code) => {
    if (code) {
      setLanguage(code);
    }
    setOpen(false);
  };

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity)
          })
        }}
      >
        <img
          src={
            theme.palette.mode === 'dark'
              ? '/static/icons/ic_language_dark.svg'
              : '/static/icons/ic_language.svg'
          }
          alt="language"
          style={{
            width: 36,
            height: 36
          }}
        />
      </IconButton>

      <MenuPopover open={open} onClose={() => handleClose(null)} anchorEl={anchorRef.current}>
        <Box sx={{ py: 1 }}>
          {languageList.map((option) => (
            <MenuItem
              key={option.code}
              selected={option.code === language}
              onClick={() => handleClose(option.code)}
              sx={{ py: 1, px: 2.5 }}
            >
              <ListItemText primaryTypographyProps={{ variant: 'body2' }}>
                {option.name}
              </ListItemText>
            </MenuItem>
          ))}
        </Box>
      </MenuPopover>
    </>
  );
}
